import React, { useEffect } from "react";
import "./About.css";
import AboutComp from "../../Components/AboutComp/AboutComp";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAboutPage } from "../../Redux/Slices/AppSlices";
import Loader from "../../Components/Loader/Loader";
import Facilities from "./Facilities"

const About = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { aboutPage, loading } = useSelector((state) => state.app);

  useEffect(() => {
    dispatch(getAboutPage());
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="admission-page">
        <div className=" landing-pages">
          <AboutComp data={aboutPage?.aboutIntro} />
        </div>
      </div>
      <div className=" landing-pages">
        {/* ===== Discourse Section ===== */}
        <section className="discourse-section">
          <div className="discourse-container">
            <p className="founder-subtitle">{aboutPage?.discourse?.subTitle}</p>

            <h2 className="founder-title">
              {aboutPage?.discourse?.title?.split(" ").slice(0, -2).join(" ")}
              <span>
                {" "}
                {aboutPage?.discourse?.title?.split(" ").slice(-2).join(" ")}
              </span>
              {/* Welcome to the <span>Kids Center</span> */}
            </h2>

            <div className="discourse-content">
              {aboutPage?.discourse?.content?.map((block, index) => {
                // helper for inline formatting
                const renderChildren = (children) =>
                  children?.map((child, i) => {
                    let text = child.text;

                    if (child.bold) {
                      text = <strong key={i}>{text}</strong>;
                    }

                    if (child.italic) {
                      text = <em key={i}>{text}</em>;
                    }

                    if (child.underline) {
                      text = <u key={i}>{text}</u>;
                    }

                    if (child.strikethrough) {
                      text = <s key={i}>{text}</s>;
                    }

                    if (child.code) {
                      text = <code key={i}>{text}</code>;
                    }

                    // links
                    if (child.type === "link") {
                      return (
                        <a
                          key={i}
                          href={child.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {child.children?.map((c) => c.text).join("")}
                        </a>
                      );
                    }

                    return <React.Fragment key={i}>{text}</React.Fragment>;
                  });

                // headings
                if (block.type === "heading") {
                  switch (block.level) {
                    case 1:
                      return (
                        <h1 key={index}>{renderChildren(block.children)}</h1>
                      );
                    case 2:
                      return (
                        <h2 key={index}>{renderChildren(block.children)}</h2>
                      );
                    case 3:
                      return (
                        <h3 key={index}>{renderChildren(block.children)}</h3>
                      );
                    case 4:
                      return (
                        <h4 key={index}>{renderChildren(block.children)}</h4>
                      );
                    case 5:
                      return (
                        <h5 key={index}>{renderChildren(block.children)}</h5>
                      );
                    case 6:
                      return (
                        <h6 key={index}>{renderChildren(block.children)}</h6>
                      );
                    default:
                      return null;
                  }
                }

                // paragraph
                if (block.type === "paragraph") {
                  return (
                    <p
                      className={index === 0 ? "dropcap" : ""}
                      key={index}
                      key={index}
                    >
                      {renderChildren(block.children)}
                    </p>
                  );
                }

                // unordered / ordered list
                if (block.type === "list") {
                  const ListTag = block.format === "ordered" ? "ol" : "ul";

                  return (
                    <ListTag key={index}>
                      {block.children?.map((item, idx) => (
                        <li key={idx}>
                          {item.children?.map((child, i) => (
                            <React.Fragment key={i}>
                              {child.text}
                            </React.Fragment>
                          ))}
                        </li>
                      ))}
                    </ListTag>
                  );
                }

                // quote
                if (block.type === "quote") {
                  return (
                    <blockquote className="quote-block" key={index}>
                      {renderChildren(block.children)}
                    </blockquote>
                  );
                }

                // code block
                if (block.type === "code") {
                  return (
                    <pre key={index}>
                      <code>{block.children?.map((c) => c.text).join("")}</code>
                    </pre>
                  );
                }

                return null;
              })}
            </div>
          </div>
        </section>
      </div>
      <div className="Founder">
        <div className="about-mission-vission landing-pages">
          <p className="founder-subtitle">{aboutPage?.valuesSubTitle}</p>

          <h2 className="founder-title">
            {aboutPage?.valuesTitle?.split(" ").slice(0, -1).join(" ")}
            <span>
              {" "}
              {aboutPage?.valuesTitle?.split(" ").slice(-1).join(" ")}
            </span>
            {/* Let's start a <span>Dialogue.</span> */}
          </h2>

          {/* ===== Timeline Section ===== */}
          <div className="timeline-section">
            {/* Center Vertical Line */}
            <div className="timeline-line"></div>

            {aboutPage?.missionVision?.map((item, index) => (
              <div
                className={`timeline-item ${index % 2 !== 0 ? "reverse" : ""}`}
                key={item.id}
              >
                <div
                  className={`timeline-content ${index % 2 !== 0 ? "right" : "left"
                    }`}
                >
                  <span className="timeline-year">
                    {index === 0
                      ? "I"
                      : index === 1
                        ? "II"
                        : index === 1
                          ? "III"
                          : index === 1
                            ? "IV"
                            : "V"}
                  </span>
                  <p className="timeline-label">{item.subTitle}</p>

                  <h3>{item.title}</h3>

                  <div className="timeline-text">
                    {item.description?.map((block, i) => {
                      if (block.type === "paragraph") {
                        return (
                          <p key={i}>
                            {block.children
                              ?.map((child) => child.text)
                              .join("")}
                          </p>
                        );
                      }

                      return null;
                    })}
                  </div>
                </div>

                <div className="timeline-dot"></div>

                <div
                  className={`timeline-image ${index % 2 !== 0 ? "left" : "right"
                    }`}
                >
                  <img src={item.image?.url} alt={item.title} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <div className="landing-pages">
        <section className="timeline-wrapper">
          <div className="timeline-grid">
            <div className="timeline-left">
              <h2 className="founder-title">
                <span>{aboutPage?.facilitiesTitle}</span>
              </h2>
              <p>{aboutPage?.facilitiesDescription}</p>
            </div>

            <div className="timeline-center">
              <div className="vertical-line"></div>

              <div className="timeline-dot top"></div>
              <div className="timeline-dot mid1"></div>
              <div className="timeline-dot mid2"></div>
              <div className="timeline-dot bottom"></div>
            </div>

            <div className="timeline-right">
              {aboutPage?.facilities?.map((item) => (
                <div className="timeline-block">
                  <h3>{item.title}</h3>
                  <p>{item.desscription}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div> */}
      <Facilities/>
    </>
  );
};

export default About;
